export const getActionAuxParamsForAnalytics = (
  printerModel,
  paas,
  country,
  language,
  error,
  derivativeName
) => {
  const params = [
    `printerModel=${printerModel}`,
    `paas=${paas}`,
    `derivativeName=${derivativeName || ''}`,
    `locale=${country?.toLowerCase?.()}-${language?.toLowerCase?.()}`
  ]

  if (error) {
    params.push(`errorReason=${error}`)
  }

  return params.join('&')
}
